// extracted by mini-css-extract-plugin
export var defaultWrapper = "_lv-3";
export var downloadButton = "_lv-4";
export var fileContainer = "_lv-9 _lv-7";
export var fileContainerBase = "_lv-7";
export var fileContainerFixedHeight = "_lv-8 _lv-7";
export var fileInfo = "_lv-5";
export var fileInfoWidthRestricted = "_lv-6";
export var fileType = "_lv-1";
export var fileTypeName = "_lv-2";
export var image = "_lv-0";
export var link = "_lv-b";
export var overflowEllipsis = "_lv-a";